
<template>

    <section class="campus-dashboard">
        
        <div class="panel">
            <div class="panel-heading"><h2>Video Library</h2></div>
            <div class="panel-body">
                
                <div class="col-xs-4">
                    <h4>Paths / Focuses</h4>
                    <VuePerfectScrollbar class="scroll-area" >
                        <ul v-if="paths" class="scroller"> 
                                          
                            <li 
                            @click.prevent="selectedPath=path.id;selectedCourses = path.courses" 
                            :class="{'selected': selectedPath === path.id}"
                            v-for="path in paths">
                                <span>{{path.name}}</span> 
                             
                            </li>
                        </ul>
                    </VuePerfectScrollbar>
                </div>
                <div class="col-xs-4">
                    <h4>Courses</h4>
                      <VuePerfectScrollbar class="scroll-area">

                        <ul class="scroller" v-if="courses" v-show="selectedCourses.length > 0">
                            <li 
                            v-for="course in courses"
                            @click.prevent="selectedInstance=course.id; selectedCourse=course.associated.courseId"
                            :class="{'selected': selectedInstance === course.id}"
                            v-if="selectedCourses.indexOf(course.associated.id) > -1">
                               {{course.associated.name}}
                            </li>
                        </ul>
                    </VuePerfectScrollbar>
                </div>

                <div class="col-xs-4">
                    <h4>Lessons</h4>
                      <VuePerfectScrollbar class="scroll-area" >
                        <ul class="scroller" v-if="lessons">
                            <li 
                            v-for="lesson in lessons"
                            @click.prevent="selectLesson(lesson.id, lesson.week)"
                            :class="{'selected': selectedLesson === lesson.id}">
                                {{lesson.title}}                                            
                            </li>
                        </ul>
                    </VuePerfectScrollbar>
                </div>

            </div>
        </div>

        <div v-if="selectedLesson">
            <video-player></video-player>
        </div>
    </section>
</template>



<script>

    import courses from '../services/courses';
    import videos from '../services/videos';

    import router from '../router';
    import VideoPlayer from './VideoPlayer';
    import VuePerfectScrollbar from 'vue-perfect-scrollbar';

    export default {
        data() {
            return {
                paths: null,
                selectedPath: null,
                courses: null,
                selectedCourses: [],
                selectedInstance: null,
                selectedCourse: null,
                lessons: null,
                selectedLesson: null,
            }
        },
        components: {VideoPlayer, VuePerfectScrollbar},
        mounted() {            
            this.getPaths();
        },
        watch: {
            selectedInstance() {
                this.getLessons();
            }
        },
        methods: {
            getPaths() {
                var self = this;
                courses.getPaths(this).then(function(response) {
                    response.data.paths.unshift({
                        id: 1,
                        name: "Foundation",
                        courses: []
                    });
                    let allPaths = response.data.paths;
                    if (localStorage.path != '9200') {
                        allPaths = allPaths.filter(p => p.id != 9200);
                    }
                    self.paths = allPaths;
                    self.getCourses();
                });
            },
            getCourses() {
                var self = this;
                courses.getMine(this).then(function(response) {
                    response.data.forEach(function(c) {
                        if (c.termType === 'foundation') {
                            let index = self.paths.findIndex(function(p) { return p.id === 1});
                            self.paths[index].courses.push(c.associated.id);
                        }
                    });
                    self.courses = response.data;
                    
                });

            },
            getLessons() {
                var self = this;
                videos.get(this, this.selectedCourse, this.selectedInstance).then(function(response) {
                    self.lessons = response.data;
                });
            },
            selectLesson(id, week) {
                this.selectedLesson = id;
                 router.replace({ 
                    path: '/campus-dashboard', 
                    name: 'campus-dashboard', 
                    params: { 
                        courseId: this.selectedCourse,
                        instanceId: this.selectedInstance, 
                        videoId: id
                    }, query: { week: week }});

            }
  
        }
    }
</script>

<style lang="scss" scoped>
    h4 {
        text-transform: uppercase;
        font-weight:100;
    }
    .selector {
        padding:0;
        border:none;
        margin-bottom:2rem;
        background:transparent;
        box-shadow: inset 0px 0px 19px -2px rgba(27,27,27,0.68);
        option {

        }
    }

    .scroll-area {
      position: relative;
      margin: auto;
      width: 100%;
      height: 200px;
      padding:0;
      margin-bottom: 2rem;
    }
    .scroller {
        margin-bottom: 2rem;
        background:#1b1b1b;
        box-shadow: inset 0px 0px 22px 0px rgba(27,27,27,0.89);
        padding:0 0;

        li {
            padding:.25rem .5rem;
            cursor: pointer;
            &.selected {
                color: #33ccff;
                background:#000;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// CampusDashboard.vue?983ec9da